import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext(null);

export function BreadcrumbProvider({ children }) {
  const [customBreadcrumbs, setCustomBreadcrumbs] = useState(null);

  const setBreadcrumbs = useCallback((breadcrumbs) => {
    setCustomBreadcrumbs(breadcrumbs);
  }, []);

  const clearBreadcrumbs = useCallback(() => {
    setCustomBreadcrumbs(null);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ customBreadcrumbs, setBreadcrumbs, clearBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbProvider');
  }
  return context;
}
